import axios from '@axios'

export default {
  getStatusesWithdrawalList(page, field) {
    return axios.post(`admin/statuses_withdrawals/list?page=${page}`, field)
  },

  getStatusWithdrawal(id) {
    return axios.get(`admin/statuses_withdrawals/${id}`)
  },

  addStatusWithdrawal(field) {
    return axios.post('admin/statuses_withdrawals', field)
  },

  updateStatusWithdrawal(field) {
    return axios.put(`admin/statuses_withdrawals/${field.id}`, field)
  },

  deleteStatusWithdrawal(field) {
    return axios.delete(`admin/statuses_withdrawals/${field.id}`, field)
  },

  restoreStatusWithdrawal(field) {
    return axios.post(`admin/statuses_withdrawals/${field.id}/restore`)
  },
}
